<template>
  <gj-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible.sync="modalVisible"
  >
    <template #header>分摊费用</template>
    <template #content>
      <div class="gj-mb10" style="padding: 0 10px">
        <el-row>
          <el-col :span="6">
            <el-row>
              <el-col class="label" :span="8">店铺</el-col>
              <el-col class="value" :span="16">{{form.marketId}}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col class="label" :span="8">费用月份</el-col>
              <el-col class="value" :span="16">{{form.feeMonth}}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col class="label" :span="8">费用名称</el-col>
              <el-col class="value" :span="16">{{form.feeName}}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col class="label" :span="8">费用金额</el-col>
              <el-col class="value" :span="16">{{form.feeAmount}}</el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="12">
            <span style="color: #888; padding-left: 21px; margin-right: 10px;"><gj-required></gj-required> 分摊日期</span>
            <span><gj-date-picker
                v-model="form.date"
                type="daterange"
                :clearable="false"
                width="340px"
            ></gj-date-picker></span>
          </el-col>
          <el-col :span="12">
            <span style="color: #888; padding-left: 22px;margin-right: 10px;"><gj-required></gj-required> 分摊规则</span>
            <span>
            <el-radio v-model="form.feeType" :label="0">天数分摊</el-radio>
            <el-radio v-model="form.feeType" :label="1">销量分摊</el-radio>
            <el-radio v-model="form.feeType" :label="2">销售额分摊</el-radio>
          </span>
          </el-col>
        </el-row>
      </div>
      <div class="gj-mb10" style="margin-top: 20px">
        <gj-button type="primary" @click.stop="addSharingGoods">选择分摊商品</gj-button>
      </div>
      <div>
        <gj-table
          :data="data"
          :columns="columns"
          :offset-height="85"
          :show-pagination="false"
        >
          <template v-slot:listingInfo="{ row }">
            <div class="text-ellipsis-1">
              {{row.listingTitle}}
            </div>
            <el-row>
              <el-col :span="12">{{row.asin}}</el-col>
              <el-col :span="12">{{row.msku}}</el-col>
            </el-row>
          </template>
          <template v-slot:sharingTotal="{ row }">
            <gj-input
              v-model="row.sharingTotal"
              width="160px"
            >
              <template #prepend>CNY</template>
            </gj-input>
          </template>
          <template v-slot:op="{ row }">
            <gj-button type="text" @click="opDetail(row.id)">详情</gj-button>
          </template>
        </gj-table>
      </div>
    </template>
    <template #footer>
      <gj-button @click="cancel">取消</gj-button>
      <gj-button @click="confirm" type="primary">确定</gj-button>
    </template>
  </gj-modal>
</template>

<script>
    import {modalMixIn} from "../../../../../minxins";
    import SharingAddGoods from './sharing-add-goods';
    import SharingDetail from './sharing-detail';

    export default {
        name: "profit-report-sharing-fee",
        mixins: [modalMixIn],
        data() {
            return {
                form: {
                    marketId: '店铺1:US',
                    feeMonth: '2020-10',
                    feeName: '广告花费',
                    feeAmount: '123.1',
                    date: [new Date(), new Date()],
                    feeType: 0,
                },
                data: [
                    {}
                ],
                columns: [
                    {id: 'market', header: '店铺/国家', field: 'marketName', minWidth: '120px',},
                    {id: 'picture', header: '图片', field: 'picture:picture', minWidth: '60px',},
                    {id: 'listingInfo', header: '商品标题/ASIN/MSKU', field: 'slot:listingInfo', minWidth: '250px',},
                    {id: 'sales', header: '销量', field: 'sales', minWidth: '120px', align: 'right'},
                    {id: 'salesAmount', header: '销售额', field: 'salesAmount', minWidth: '120px', align: 'right'},
                    {id: 'sharingTotal', header: '分摊总金额', field: 'slot:sharingTotal', minWidth: '160px', align: 'right'},
                    {id: 'op', header: '分摊详情', field: 'slot:op', minWidth: '60px',},
                ],
            }
        },
        methods: {
            opDetail(id) {
                this.$gjCreate(SharingDetail)
            },
            addSharingGoods() {
                this.$gjCreate(SharingAddGoods)
            }
        }
    }
</script>

<style scoped>
  .value {
    color: #333;
  }
  .label {
    color: #888;
    text-align: right;
    padding-right: 10px;
  }
</style>
